import { render, staticRenderFns } from "./AdminNotificationBanners.vue?vue&type=template&id=6077c9d8&scoped=true&"
import script from "./AdminNotificationBanners.vue?vue&type=script&lang=ts&"
export * from "./AdminNotificationBanners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6077c9d8",
  null
  
)

export default component.exports